import React, { useState, ChangeEvent, useCallback } from 'react'
import { useStyles } from './style'

const ImageUpload: React.FC = () => {
  const [image, setImage] = useState<File | null>(null)
  const [preview, setPreview] = useState<string | null>(null)

  const style = useStyles()

  const handleImageChange = useCallback((e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0]
      setImage(file)
      setPreview(URL.createObjectURL(file))
    }
  }, [])

  return (
    <div>
      <input
        id='image-upload'
        type='file'
        accept='image/*'
        onChange={handleImageChange}
        className={style.hiddenInput}
      />
      <label htmlFor='image-upload' className={style.uploadLabel}>
        Trocar foto de perfil
      </label>
      {image && <p>Imagem selecionada: {image.name}</p>}
      {preview && <img src={preview} alt='Preview' className={style.previewImage} />}
    </div>
  )
}

export default ImageUpload
